var _mask, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: "1em",
    viewBox: "0 0 16 16",
    width: "1em",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M1.334 8a6.666 6.666 0 0 1 6.667-6.667A6.666 6.666 0 0 1 14.667 8a6.666 6.666 0 0 1-6.666 6.667A6.666 6.666 0 0 1 1.334 8zm1.667 0a5 5 0 0 1 5-5 5 5 0 0 1 5 5 5 5 0 0 1-5 5 5 5 0 0 1-5-5z",
    fillRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M1.334 8a6.666 6.666 0 0 1 6.667-6.667A6.666 6.666 0 0 1 14.667 8a6.666 6.666 0 0 1-6.666 6.667A6.666 6.666 0 0 1 1.334 8zm1.667 0a5 5 0 0 1 5-5 5 5 0 0 1 5 5 5 5 0 0 1-5 5 5 5 0 0 1-5-5z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 .333A7.666 7.666 0 0 0 .335 8h2a5.666 5.666 0 0 1 5.667-5.667zM15.668 8A7.666 7.666 0 0 0 8.001.333v2A5.666 5.666 0 0 1 13.667 8zm-7.666 7.667A7.666 7.666 0 0 0 15.667 8h-2a5.666 5.666 0 0 1-5.666 5.667zM.334 8a7.666 7.666 0 0 0 7.667 7.667v-2A5.666 5.666 0 0 1 2.334 8zm7.667-6a6 6 0 0 0-6 6h2a4 4 0 0 1 4-4zm6 6a6 6 0 0 0-6-6v2a4 4 0 0 1 4 4zm-6 6a6 6 0 0 0 6-6h-2a4 4 0 0 1-4 4zM2 8a6 6 0 0 0 6 6v-2a4 4 0 0 1-4-4z",
    mask: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.334 5.167a.5.5 0 1 0-1 0v3.5l3.092 1.855a.479.479 0 1 0 .491-.823L8.334 8.167z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.b859000d.svg";
export { ForwardRef as ReactComponent };